import React, {Fragment} from "react";
import ReactHookFormError from "./ReactHookFormError";

const FormItemTextArea = ({ heading, name, formSectionName,  register, formErrors }) =>
{
    const elementName = formSectionName === undefined ? name : formSectionName + '.' + name ;

    return (
        <Fragment key={name}>
            <label key={name+'lab'}>{heading}</label>
            <textarea key={name+'txt'} className='form-control' {...register(elementName, {
                required: false,
                maxLength: 2000
            })} />
            <ReactHookFormError formErrors={formErrors} name={name} key={name+'rhe'}/>
        </Fragment>
    )
}

export default FormItemTextArea;
